document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-kk-mobile-buy-bar]').forEach((buyBar) => {
    const primaryButton = document.querySelector(`#${buyBar.dataset.primaryButton}`);
    if (!primaryButton || !window.IntersectionObserver) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const footer = document.querySelector('footer');
    // Le bon cadeau contient plusieurs champs avant le bouton principal.
    // Ne pas afficher la barre fixe tant que cette zone de personnalisation
    // est à l'écran : elle ne doit jamais recouvrir les libellés ou les champs.
    const contextualForm = primaryButton.form?.querySelector('.kk-gift-personalization');
    let primaryVisible = true;
    let footerVisible = false;
    let contextVisible = Boolean(contextualForm);
    const updateBuyBar = () => {
      buyBar.hidden = !mobileQuery.matches || primaryVisible || footerVisible || contextVisible;
    };

    new IntersectionObserver(([entry]) => {
      primaryVisible = entry.isIntersecting;
      updateBuyBar();
    }, { threshold: 0.15 }).observe(primaryButton);

    if (contextualForm) {
      new IntersectionObserver(([entry]) => {
        contextVisible = entry.isIntersecting;
        updateBuyBar();
      }, { threshold: 0 }).observe(contextualForm);
    }

    if (footer) {
      new IntersectionObserver(([entry]) => {
        footerVisible = entry.isIntersecting;
        updateBuyBar();
      }, { threshold: 0.05 }).observe(footer);
    }
    mobileQuery.addEventListener('change', updateBuyBar);
    updateBuyBar();
  });

  document.querySelectorAll('recipient-form').forEach((recipientForm) => {
    const checkbox = recipientForm.querySelector('input[type="checkbox"]');
    const email = recipientForm.querySelector('input[name="properties[Recipient email]"]');
    if (!checkbox || !email) return;
    const updateRequiredState = () => { email.required = checkbox.checked; };
    checkbox.addEventListener('change', updateRequiredState);
    updateRequiredState();
  });

  document.querySelectorAll('.kk-gift-product form[data-type="add-to-cart-form"]').forEach((giftForm) => {
    const beneficiary = giftForm.querySelector('[data-gift-beneficiary]');
    const error = giftForm.querySelector('[data-gift-beneficiary-error]');
    if (!beneficiary || !error) return;
    giftForm.addEventListener('submit', (event) => {
      const valid = beneficiary.value.trim().length > 1;
      beneficiary.setAttribute('aria-invalid', valid ? 'false' : 'true');
      error.hidden = valid;
      if (!valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        beneficiary.focus();
      }
    }, true);
    beneficiary.addEventListener('input', () => {
      if (beneficiary.value.trim().length > 1) {
        beneficiary.setAttribute('aria-invalid', 'false');
        error.hidden = true;
      }
    });
  });
});
